//Import views here
import Home from "../views/home";
import OurHistory from "../views/ourHistory";
import Suits from "../views/suits";
import ClubSuits from "../views/clubSuits";
import SuitBuilder from '../views/suitBuilder';
import SuitAlpine from "../views/suits/alpine";
import SuitBobsleigh from "../views/suits/bobsleigh";
import SuitLuge from "../views/suits/luge";
import SuitSkeleton from "../views/suits/skeleton";
import SuitSpeedSkating from "../views/suits/speedskating";

import PageNotFound from "../views/pageNotFound";

import Reasearch from "../views/research";
import Contact from "../views/contact";

import PrivacyPolicy from "../views/privacyPolicy";
import TermsOfService from "../views/termsOfService";

const routes = [
	{
		path: "/",
		component: Home,
		exact: true
	},
	{
		path: "/history",
		component: OurHistory
	},
	{
		path: "/suits",
		component: Suits,
		exact: true
	},
	{
		path: "/clubsuits",
		component: ClubSuits
	},
	{
	     path: '/suitbuilder',
	     component: SuitBuilder
	},
	{
		path: "/suits/alpine",
		component: SuitAlpine
	},
	{
		path: "/suits/bobsleigh",
		component: SuitBobsleigh
	},
	{
		path: "/suits/luge",
		component: SuitLuge
	},
	{
		path: "/suits/skeleton",
		component: SuitSkeleton
	},
	{
		path: "/suits/speedskating",
		component: SuitSpeedSkating
	},
	{
		path: "/research",
		component: Reasearch
	},
	{
		path: "/contact",
		component: Contact
	},
	{
		path: "/privacy-policy",
		component: PrivacyPolicy
	},
	{
		path: "/terms-of-service",
		component: TermsOfService
	},

	{
		path: "**",
		component: PageNotFound
	}
];

module.exports = routes;
